import React, { FunctionComponent } from 'react';

import { SettingsEnableDisable } from '@components/settings/shared/settings-enable-disable';

interface ShowMetadataProps {
  defaultEnabled: boolean | null;
}

const ShowMetadata: FunctionComponent<ShowMetadataProps> = ({ defaultEnabled }) => (
  <SettingsEnableDisable
    defaultEnabled={defaultEnabled === null ? true : defaultEnabled}
    description={bfTranslate('Only applies to assets in Collections and Share Links')}
    errorTitle={bfTranslate('Error updating metadata viewing permissions. Please contact support.')}
    id="show-metadata"
    successTitle={bfTranslate('Metadata viewing permissions updated!')}
    title={bfTranslate('Allow guest and public users to see metadata')}
    updateResourceKey="showMetadata"
  />
);

export default ShowMetadata;
